import React from 'react';

import { SEO } from 'main/components';
import {
  DualUse,
  FirstSpecs,
  Hero,
  LearnMore,
  ProductOrigin,
  SecondSpecs,
} from 'modules/wingcore';

export const Wingcore = () => {
  return (
    <>
      <SEO seoTitle="H7 WingCore - NDAA-Compliant Fixed-Wing Flight Controller" />
      <section className="wingcore-section">
        <Hero />
        <ProductOrigin />
        <DualUse />
        <FirstSpecs />
        <SecondSpecs />
        <LearnMore />
      </section>
    </>
  );
};
